var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-overview" },
    [
      _vm._l(_vm.activeFilters, function (filter) {
        return _c("div", { key: filter.id }, [
          _vm._v("\n\t\t" + _vm._s(filter.displayName)),
          filter.groupId
            ? _c("small", [_vm._v(" (" + _vm._s(filter.groupId) + ")")])
            : _vm._e(),
          _vm._v(": "),
          _c("i", [_vm._v(_vm._s(_vm.summaryMap[filter.id]))]),
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sub-corpus-size" },
        [
          _vm.error
            ? [_vm._v("\n\t\t\tError: " + _vm._s(_vm.error.message) + "\n\t\t")]
            : _vm.subCorpusStats
            ? [
                _vm._v("\n\t\t\tSelected subcorpus:"),
                _c("br"),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: {
                      display: "inline-block",
                      "vertical-align": "top",
                      "text-align": "right",
                      "font-family": "monospace",
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t " +
                        _vm._s(
                          _vm.subCorpusStats.summary.numberOfDocs.toLocaleString()
                        )
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t " +
                        _vm._s(
                          _vm.subCorpusStats.summary.tokensInMatchingDocuments.toLocaleString()
                        ) +
                        "\n\t\t\t"
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticStyle: {
                      display: "inline-block",
                      "vertical-align": "top",
                      "text-align": "right",
                      "font-family": "monospace",
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t (" +
                        _vm._s(
                          _vm._f("frac2Percent")(
                            _vm.subCorpusStats.summary.numberOfDocs /
                              _vm.totalCorpusDocs
                          )
                        ) +
                        ")"
                    ),
                    _c("br"),
                    _vm._v(
                      "\n\t\t\t\t (" +
                        _vm._s(
                          _vm._f("frac2Percent")(
                            _vm.subCorpusStats.summary
                              .tokensInMatchingDocuments / _vm.totalCorpusTokens
                          )
                        ) +
                        ")\n\t\t\t"
                    ),
                  ]
                ),
              ]
            : [
                _c("span", {
                  staticClass:
                    "fa fa-spinner fa-spin searchIndicator totals-spinner",
                }),
                _vm._v(
                  "\n\t\t\tCalculating size of selected subcorpus...\n\t\t"
                ),
              ],
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticStyle: { display: "inline-block", "vertical-align": "top" } },
      [
        _vm._v("\n\t\t\t\tTotal documents:"),
        _c("br"),
        _vm._v("\n\t\t\t\tTotal tokens:\n\t\t\t"),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }